module.exports = __webpack_public_path__ + "media/preview/conference@4x-f0f0e172.png";